export const UPDATE_FAMILY_ITEM = 'UPDATE_FAMILY_ITEM';
export const updateFamilyItem = (id, family, activeKey) => ({
  type: UPDATE_FAMILY_ITEM,
  payload: {
    id,
    family,
    activeKey,
  },
});

export const LIST_ALL_FAMILY = 'LIST_ALL_FAMILY';
export const listAllFamily = () => ({
  type: LIST_ALL_FAMILY,
  payload: {},
});
